var ko = require('knockout'),
  $ = require('jquery'),
  APIHelper = require('_js/APIHelper'),
  RNStorage = require('_utils/storage'),
  FormDropdown = require('_components/atoms/form/form-dropdown/form-dropdown');

var WARNING_TRIGGER_STATUS = 'Manuell godkjenning';
var POST_SUCCESS_MESSAGE = 'Oppdaterte kursdeltaker(e)';
var MANUAL_CONFIRMATION_REQUIRED =
  'Et eller flere kurs krever manuell godkjenning. Finn deltakere som er markert med manuell godkjenning og rediger antall timer som er godkjent.';
var STORAGE_KEY = 'courseParticipantsList';

var POLLING_INTERVAL_PARTICIPANTS = 30000;
var POLLING_INTERVAL_ANONYMOUS_PARTICIPANTS = 29000;
var POLLING_TIMEOUT_PARTICIPANTS = null;
var POLLING_TIMEOUT_ANONYMOUS_PARTICIPANTS = null;
var POLLING_CURRENTREQ_PARTICIPANTS = null;
var POLLING_CURRENTREQ_ANONYMOUS_PARTICIPANTS = null;

function CourseParticipantsList(params) {
  var self = this;

  self.params = params;
  self.API = params.api;
  self.navigation = params.navigation;
  self.sequencePk = params.values.sequencePk;
}

CourseParticipantsList.prototype.init = function(element) {
  var self = this;
  self.$element = $(element);
  self.enableAutoUpdate = ko.observable(true);

  self.errorMessage = ko.observable();
  self.hasError = ko.computed(function() {
    return !!self.errorMessage() && self.errorMessage().length > 0;
  });

  self.successMessage = ko.observable();
  self.hasSuccess = ko.computed(function() {
    return !!self.successMessage() && self.successMessage().length > 0;
  });

  self.isIE = /*@cc_on!@*/ false || !!document.documentMode;
  self.isEdge = !self.isIE && !!window.StyleMedia;

  self.infoMessage = ko.observable();
  self.isLoading = ko.observable(false);
  self.isLoadingSequenceInfo = ko.observable(false);
  self.isAnonLoading = ko.observable(false);

  self.isModalActive = ko.observable(false);
  self.isModalActive.subscribe(function(value) {
    self.errorMessage('');
    self.successMessage('');
    if (!value) {
      self.updateOptions();

      if (!self.enableBatchEditMode()) {
        self.selectedParticipantsToEdit([]);
      }
    }
  });

  self.enableBatchEditMode = ko.observable(false);
  self.enableBatchEditMode.subscribe(function() {
    self.checkAllParticipants(false);
    self.selectedParticipantsToEdit([]);
  });
  self.selectedParticipantsToEdit = ko.observableArray([]);

  self.numberOfSelectedParticipants = ko.computed(function() {
    return self.selectedParticipantsToEdit().length;
  });
  self.sequenceInfo = ko.observable({});
  self.showMoreSequences = ko.observable(false);
  self.participants = ko.observableArray([]);
  self.incomingParticipants = ko.observableArray([]);
  self.anonymousParticipants = ko.observableArray([]);
  self.incomingAnonymousParticipants = ko.observable([]);
  self.noParticipantsFound = ko.observable(false);
  self.noAnonsFound = ko.observable(false);

  self.getSequenceInfo();
  self.getParticipants();
  self.getAnonymousParticipants();

  self.enableAutoUpdate.subscribe(function(value) {
    if (value) {
      self.getParticipantsInIntervals();
      self.getAnonymousParticipantsInIntervals();
    }
  });

  self.numberOfParticipants = ko.computed(function() {
    return self.participants().length;
  });
  self.numberOfShowingParticipants = ko.observable();
  self.numberOfShowingAnonymousParticipants = ko.observable();
  self.numberOfAnonymousParticipants = ko.computed(function() {
    return self.anonymousParticipants().length;
  });

  self.numberOfMissingStartTime = ko.computed(function() {
    var missing = 0;

    self.participants().forEach(function(participant) {
      participant.Attendance.forEach(function(day) {
        if (day.CheckInTime() === '') missing++;
      });
    });

    return missing;
  });
  self.numberOfMissingEndTime = ko.computed(function() {
    var missing = 0;

    self.participants().forEach(function(participant) {
      participant.Attendance.forEach(function(day) {
        if (day.CheckOutTime() === '') missing++;
      });
    });

    return missing;
  });

  self.hasMoreSequences = ko.computed(function() {
    if (
      self.sequenceInfo().SequencesSameDay &&
      self.sequenceInfo().SequencesSameDay.length > 0
    )
      return true;
  });

  //Filter
  self.meetingDateFilterOptions = ko.observableArray();
  self.selectedFilterMeetingDate = ko.observable();
  self.participantFilterOptions = ko.observableArray();
  self.anonymousParticipantsFilterOptions = ko.observableArray();
  self.selectedFilterParticipant = ko.observable();
  self.selectedFilterAnonymousParticipants = ko.observable();
  self.filteredParticipants = ko.computed(self.filterParticipants.bind(this));
  self.filteredAnonymousParticipants = ko.computed(
    self.filterAnonymousParticipants.bind(this)
  );

  self.activeSort = self.listHeaders[0];

  self.checkAllParticipants = ko.observable(false);
  self.checkAllParticipants.subscribe(function(value) {
    self.selectedParticipantsToEdit([]);
    if (value) {
      self.selectedParticipantsToEdit(self.filteredParticipants());
    }
  });

  var formDropdown = new FormDropdown();
  formDropdown.start('.form-dropdown-open-button');
};

CourseParticipantsList.prototype.postOnKey = function(data, event) {
  if (event.keyCode === 13 && event.key === 'Enter') {
    event.preventDefault();
    $(event.target).blur();
  }

  return true;
};

CourseParticipantsList.prototype.updateParticipantLists = function() {
  var self = this;

  self.getParticipants();
  self.getAnonymousParticipants();
};

CourseParticipantsList.prototype.toggleModal = function(participant) {
  var self = this;

  if (participant) {
    self.selectedParticipantsToEdit([participant]);
  }

  if (!self.isModalActive()) {
    self.isModalActive(true);
  } else {
    self.isModalActive(false);
  }
};

CourseParticipantsList.prototype.onMobileNumberChange = function(participant) {
  var self = this;
  self.postMobileNumber(participant);
};

CourseParticipantsList.prototype.onCheckInTimeChange = function(
  participant,
  attendance
) {
  this.postCheckInTime(
    this.selectedParticipantsToEdit().length > 0
      ? this.selectedParticipantsToEdit()
      : [participant],
    attendance
  );
};

CourseParticipantsList.prototype.onCheckOutTimeChange = function(
  participant,
  attendance
) {
  var self = this;

  self.postCheckOutTime(
    self.selectedParticipantsToEdit().length > 0
      ? self.selectedParticipantsToEdit()
      : [participant],
    attendance
  );
};

CourseParticipantsList.prototype.makeParticipantPropertiesObservables = function(
  participant
) {
  var self = this;

  participant.ParticipantIsLoading = ko.observable(false);
  participant.MobileNumber = ko.observable(participant.MobileNumber);

  participant.Attendance.forEach(function(attendance) {
    attendance.CheckInTime = ko.observable(
      self.getTimeFromDate(attendance.CheckInTime)
    );
    attendance.CheckOutTime = ko.observable(
      self.getTimeFromDate(attendance.CheckOutTime)
    );
  });

  participant.StatusTexts = ko.observableArray(participant.StatusTexts);

  if (participant.StatusTexts().indexOf(WARNING_TRIGGER_STATUS) !== -1) {
    self.infoMessage(MANUAL_CONFIRMATION_REQUIRED);
  }
  participant.StatusTexts.subscribe(function(texts) {
    if (texts.indexOf(WARNING_TRIGGER_STATUS) !== -1) {
      self.infoMessage(MANUAL_CONFIRMATION_REQUIRED);
    }
  });

  participant.ApprovedHours.forEach(function(hours) {
    var tmp = hours.ApprovedHours;
    if (self.isIE || self.isEdge) {
      tmp = tmp.toLocaleString('nb-NO');
    }
    hours.ApprovedHours = ko.observable(tmp).extend({
      required: [
        {
          type: 'isValidCalculatorHour',
          message: 'Det er kun gyldig med hele eller halve timer'
        }
      ]
    });
  });
};

CourseParticipantsList.prototype.createSubscribersForSelectedFilters = function() {
  this.selectedFilterParticipant.subscribe(this.updateLocalStorage.bind(this));
  this.selectedFilterAnonymousParticipants.subscribe(
    this.updateLocalStorage.bind(this)
  );
};

CourseParticipantsList.prototype.updateLocalStorage = function() {
  var filters = {
    filterParticipant: this.selectedFilterParticipant(),
    filterAnonymousParticipants: this.selectedFilterAnonymousParticipants()
  };

  RNStorage.storeItem(STORAGE_KEY, filters);
};

CourseParticipantsList.prototype.applyStoredFilters = function() {
  var filters = JSON.parse(RNStorage.getItem(STORAGE_KEY));
  if (filters !== null && filters !== undefined) {
    this.selectedFilterParticipant(filters.filterParticipant);
    this.selectedFilterAnonymousParticipants(
      filters.filterAnonymousParticipants
    );
  }
};

CourseParticipantsList.prototype.listHeaders = [
  { title: 'Navn', sortKey: 'name', addClass: 'large-4', asc: true },
  { title: 'AktørId', sortKey: 'id', addClass: 'large-1', asc: true },
  { title: 'Mobil', sortKey: 'number', addClass: 'large-1', asc: true },
  { title: 'Inn', sortKey: 'timestamp', addClass: 'large-1', asc: true },
  { title: 'Ut', sortKey: 'timestamp', addClass: 'large-1', asc: true },
  { title: 'Status', sortKey: 'status', addClass: 'large-1', asc: true },
  { title: '', sortKey: '', addClass: 'large-3', asc: true }
];

CourseParticipantsList.prototype.anonymousListHeaders = [
  { title: '', sortKey: '', addClass: 'large-5', asc: true },
  { title: 'Mobil', sortKey: 'number', addClass: 'large-1', asc: true },
  { title: 'inn', sortKey: 'string', addClass: 'large-1', asc: true },
  { title: 'ut', sortKey: 'string', addClass: 'large-1', asc: true },
  { title: '', sortKey: '', addClass: 'large-4', asc: true }
];

CourseParticipantsList.prototype.compareMobileNumbers = function(participant) {
  var self = this;

  self.anonymousParticipants().forEach(function(anon) {
    if (anon.MobileNumber() === participant.MobileNumber()) {
      anon.IsRegisteredUser(true);
    }
  });
};

CourseParticipantsList.prototype.postMobileNumber = function(participant) {
  var self = this;
  self.errorMessage('');
  self.successMessage('');

  participant.ParticipantIsLoading(true);

  APIHelper.post(
    self.getPostMobileNumberUrl(participant),
    {},
    function(response) {
      if (!response.SavedData) {
        self.errorMessage(response.ErrorMessage);
      } else {
        self.successMessage(POST_SUCCESS_MESSAGE);
      }

      response.Participant.Attendance.forEach(function(day) {
        participant.Attendance.forEach(function(oldday) {
          if (day.AttendancePk === oldday.AttendancePk) {
            oldday.CheckInTime(self.getTimeFromDate(day.CheckInTime));
            oldday.CheckOutTime(self.getTimeFromDate(day.CheckOutTime));
          }
        });
      });

      participant.MobileNumber(response.Participant.MobileNumber);
      participant.StatusTexts(response.Participant.StatusTexts);
      self.UpdateApprovedHours(participant, response.Participant.ApprovedHours);

      self.updateOptions();
      participant.ParticipantIsLoading(false);
    },
    function(response) {
      self.errorMessage(response.ErrorMessage);
      participant.MobileNumber('');
      participant.ParticipantIsLoading(false);
    }
  );
};

CourseParticipantsList.prototype.UpdateApprovedHours = function(
  participant,
  approvedHours
) {
  var self = this;
  participant.ApprovedHours.forEach(function(hours) {
    var index = participant.ApprovedHours.indexOf(hours);
    var val = ko.isObservable(approvedHours[index].ApprovedHours)
      ? approvedHours[index].ApprovedHours()
      : approvedHours[index].ApprovedHours;
    if (self.isIE || self.isEdge) {
      val = val.toLocaleString('nb-NO');
    }

    if (val != hours.ApprovedHours()) {
      hours.ApprovedHours(val);
    }
  });
};

CourseParticipantsList.prototype.postCheckInTime = function(
  participants,
  attendance
) {
  var self = this;
  self.errorMessage('');
  self.successMessage('');
  var data = [];

  participants.forEach(function(participant) {
    participant.ParticipantIsLoading(true);
    data.push(participant.ParticipantActorId);
  });

  APIHelper.QcPost(
    self.getPostCheckInTimeUrl(attendance),
    data,
    function(response) {
      response.forEach(function(obj) {
        if (!obj.SavedData) {
          self.errorMessage(obj.ErrorMessage);
        } else if (!self.hasError()) {
          self.successMessage(POST_SUCCESS_MESSAGE);
        }

        obj.Participant.Attendance.forEach(function(thatDay) {
          participants.forEach(function(participant) {
            participant.Attendance.forEach(function(thisDay) {
              if (thatDay.AttendancePk === thisDay.AttendancePk) {
                thisDay.CheckInTime(self.getTimeFromDate(thatDay.CheckInTime));
              } else if (
                thisDay.AttendancePk === 0 &&
                thatDay.DayInSequence === thisDay.DayInSequence
              ) {
                thisDay.CheckInTime(self.getTimeFromDate(thatDay.CheckInTime));
                thisDay.AttendancePk = thatDay.AttendancePk;
              }
            });
          });
        });
      });

      participants.forEach(function(participant) {
        response.forEach(function(obj) {
          if (
            participant.ParticipantActorId ===
            obj.Participant.ParticipantActorId
          ) {
            participant.StatusTexts(obj.Participant.StatusTexts);
            self.UpdateApprovedHours(
              participant,
              obj.Participant.ApprovedHours
            );
          }
          participant.ParticipantIsLoading(false);
        });
      });

      self.updateOptions();
    },
    function(response) {
      self.errorMessage(response.ErrorMessage);
    }
  );
};

CourseParticipantsList.prototype.postCheckOutTime = function(
  participants,
  attendance
) {
  var self = this;
  self.errorMessage('');
  self.successMessage('');
  var data = [];

  participants.forEach(function(participant) {
    participant.ParticipantIsLoading(true);
    data.push(participant.ParticipantActorId);
  });

  APIHelper.QcPost(
    self.getPostCheckOutTimeUrl(attendance),
    data,
    function(response) {
      response.forEach(function(obj) {
        if (!obj.SavedData) {
          self.errorMessage(obj.ErrorMessage);
        } else if (!self.hasError()) {
          self.successMessage(POST_SUCCESS_MESSAGE);
        }

        obj.Participant.Attendance.forEach(function(thatDay) {
          participants.forEach(function(participant) {
            participant.Attendance.forEach(function(thisDay) {
              if (thatDay.AttendancePk === thisDay.AttendancePk) {
                thisDay.CheckOutTime(
                  self.getTimeFromDate(thatDay.CheckOutTime)
                );
              } else if (
                thisDay.AttendancePk === 0 &&
                thatDay.DayInSequence === thisDay.DayInSequence
              ) {
                thisDay.CheckOutTime(
                  self.getTimeFromDate(thatDay.CheckOutTime)
                );
                thisDay.AttendancePk = thatDay.AttendancePk;
              }
            });
          });
        });
      });

      participants.forEach(function(participant) {
        response.forEach(function(obj) {
          if (
            participant.ParticipantActorId ===
            obj.Participant.ParticipantActorId
          ) {
            participant.StatusTexts(obj.Participant.StatusTexts);
            self.UpdateApprovedHours(
              participant,
              obj.Participant.ApprovedHours
            );
          }
          participant.ParticipantIsLoading(false);
        });
      });

      self.updateOptions();
    },
    function(response) {
      self.errorMessage(response.ErrorMessage);
    }
  );
};

CourseParticipantsList.prototype.getSequenceInfo = function() {
  var self = this;
  self.isLoadingSequenceInfo(true);
  var url = self.getSequenceInfoUrl() + '?sequencePk=' + self.sequencePk;

  APIHelper.get(
    url,
    function(response) {
      self.sequenceInfo(response);
      self.isLoadingSequenceInfo(false);
    },
    function(response) {
      self.errorMessage(response.ErrorMessage);
      self.isLoadingSequenceInfo(false);
    }
  );
};

CourseParticipantsList.prototype.getAnonymousParticipants = function() {
  var self = this;
  self.isAnonLoading(true);
  self.noAnonsFound(true);
  var url =
    self.getUrlParticipantsBase() +
    self.API.getAnonymousParticipants +
    '?sequencePk=' +
    self.sequencePk;

  if (self.anonymousParticipants().length > 0) {
    self.anonymousParticipants([]);
  }

  APIHelper.get(
    url,
    function(data) {
      if (data.length === 0) {
        self.noAnonsFound(true);
      } else {
        self.noAnonsFound(false);
        data.forEach(function(anon) {
          anon.IsRegisteredUser = ko.observable(false);
          anon.MobileNumber = ko.observable(anon.ParticipantMobileNumber);
          anon.CheckInTime = ko.observable(
            self.getTimeFromDate(anon.CheckInTime)
          );
          anon.CheckOutTime = ko.observable(
            self.getTimeFromDate(anon.CheckOutTime)
          );
          self.anonymousParticipants.push(anon);
        });
      }

      if (self.enableAutoUpdate()) {
        self.getAnonymousParticipantsInIntervals();
      }
      self.isAnonLoading(false);
    },
    function(error) {
      self.errorMessage(
        error.responseJSON ? error.responseJSON.message : error
      );
      self.isAnonLoading(false);
    }
  );
};

CourseParticipantsList.prototype.getAnonymousParticipantsInIntervals = function() {
  var self = this;
  var url =
    self.getUrlParticipantsBase() +
    self.API.getAnonymousParticipants +
    '?sequencePk=' +
    self.sequencePk;
  self.incomingAnonymousParticipants([]);

  if (!self.enableAutoUpdate()) return;

  POLLING_CURRENTREQ_ANONYMOUS_PARTICIPANTS = $.get(url);

  POLLING_CURRENTREQ_ANONYMOUS_PARTICIPANTS.done(function(
    anonymousParticipants
  ) {
    self.noAnonsFound(anonymousParticipants.length > 0 ? false : true);

    if (self.enableBatchEditMode()) return;
    anonymousParticipants.forEach(function(anon) {
      anon.IsRegisteredUser = ko.observable(false);
      anon.MobileNumber = ko.observable(anon.ParticipantMobileNumber);
      anon.CheckInTime = ko.observable(self.getTimeFromDate(anon.CheckInTime));
      anon.CheckOutTime = ko.observable(
        self.getTimeFromDate(anon.CheckOutTime)
      );
      self.incomingAnonymousParticipants().push(anon);
    });

    self.incomingAnonymousParticipants().forEach(function(incomingParticipant) {
      var participantOnlyLocally = true;
      self.anonymousParticipants().forEach(function(existingParticipant) {
        if (
          incomingParticipant.MobileNumber() ===
          existingParticipant.MobileNumber()
        ) {
          participantOnlyLocally = false;
        }
      });

      //add new participant
      if (participantOnlyLocally) {
        self.anonymousParticipants.push(incomingParticipant);
      }
    });

    self.anonymousParticipants().forEach(function(existingParticipant) {
      var existingId = existingParticipant.MobileNumber();
      var participantOnlyInIncoming = true;
      self
        .incomingAnonymousParticipants()
        .forEach(function(incomingParticipant) {
          var incomingId = incomingParticipant.MobileNumber();

          if (existingId === incomingId) {
            participantOnlyInIncoming = false;

            if (
              existingParticipant.CheckInTime() !==
              incomingParticipant.CheckInTime()
            ) {
              existingParticipant.CheckInTime(
                incomingParticipant.CheckInTime()
              );
            }

            if (
              existingParticipant.CheckOutTime() !==
              incomingParticipant.CheckOutTime()
            ) {
              existingParticipant.CheckOutTime(
                incomingParticipant.CheckOutTime()
              );
            }
          }
        });

      //delete participant
      if (participantOnlyInIncoming) {
        self.anonymousParticipants.remove(existingParticipant);
      }
    });
  });

  POLLING_CURRENTREQ_ANONYMOUS_PARTICIPANTS.always(function() {
    if (POLLING_CURRENTREQ_ANONYMOUS_PARTICIPANTS) {
      POLLING_CURRENTREQ_ANONYMOUS_PARTICIPANTS.abort();
    }

    if (POLLING_TIMEOUT_ANONYMOUS_PARTICIPANTS) {
      clearTimeout(POLLING_TIMEOUT_ANONYMOUS_PARTICIPANTS);
    }

    POLLING_CURRENTREQ_ANONYMOUS_PARTICIPANTS = null;

    POLLING_TIMEOUT_ANONYMOUS_PARTICIPANTS = setTimeout(
      self.getAnonymousParticipantsInIntervals.bind(self),
      POLLING_INTERVAL_ANONYMOUS_PARTICIPANTS
    );
  });
};

CourseParticipantsList.prototype.getParticipantsInIntervals = function() {
  var self = this;
  var url =
    self.getUrlParticipantsBase() +
    self.API.getParticipants +
    '?sequencePk=' +
    self.sequencePk;
  self.incomingParticipants([]);

  if (!self.enableAutoUpdate()) return;

  POLLING_CURRENTREQ_PARTICIPANTS = $.get(url);

  POLLING_CURRENTREQ_PARTICIPANTS.done(function(participants) {
    if (self.enableBatchEditMode()) return;

    participants.forEach(function(participant) {
      self.makeParticipantPropertiesObservables(participant);
      self.incomingParticipants().push(participant);
    });

    self.incomingParticipants().forEach(function(incomingParticipant) {
      var participantOnlyLocally = true;
      self.participants().forEach(function(existingParticipant) {
        if (
          incomingParticipant.ParticipantActorId ===
          existingParticipant.ParticipantActorId
        ) {
          participantOnlyLocally = false;
        }
      });

      //add new participant
      if (participantOnlyLocally) {
        self.participants.push(incomingParticipant);
      }
    });

    self.participants().forEach(function(existingParticipant) {
      var existingAktorId = existingParticipant.ParticipantActorId;
      var participantOnlyInIncoming = true;
      self.incomingParticipants().forEach(function(incomingParticipant) {
        var incomingAktorId = incomingParticipant.ParticipantActorId;

        if (existingAktorId === incomingAktorId) {
          participantOnlyInIncoming = false;
          //check phone number
          if (
            existingParticipant.MobileNumber() !==
            incomingParticipant.MobileNumber()
          ) {
            existingParticipant.ParticipantIsLoading(true);
            existingParticipant.MobileNumber(
              incomingParticipant.MobileNumber()
            );
          }

          //check attendance
          existingParticipant.Attendance.forEach(function(
            existingParticipantDay
          ) {
            incomingParticipant.Attendance.forEach(function(
              incomingParticipantDay
            ) {
              if (
                existingParticipantDay.AttendancePk ===
                  incomingParticipantDay.AttendancePk ||
                existingParticipantDay.AttendancePk === 0
              ) {
                if (
                  existingParticipantDay.CheckInTime() !==
                  incomingParticipantDay.CheckInTime()
                ) {
                  existingParticipant.ParticipantIsLoading(true);
                  existingParticipantDay.CheckInTime(
                    incomingParticipantDay.CheckInTime()
                  );
                }

                if (
                  existingParticipantDay.CheckOutTime() !==
                  incomingParticipantDay.CheckOutTime()
                ) {
                  existingParticipant.ParticipantIsLoading(true);
                  existingParticipantDay.CheckOutTime(
                    incomingParticipantDay.CheckOutTime()
                  );
                }
              }
            });
          });

          //update statustext and approved hours
          existingParticipant.StatusTexts(incomingParticipant.StatusTexts());
          self.UpdateApprovedHours(
            existingParticipant,
            incomingParticipant.ApprovedHours
          );
        }

        setTimeout(function() {
          existingParticipant.ParticipantIsLoading(false);
        }, 3000);
      });

      //delete participant
      if (participantOnlyInIncoming) {
        self.participants.remove(existingParticipant);
      }
    });
  });

  POLLING_CURRENTREQ_PARTICIPANTS.always(function() {
    if (POLLING_CURRENTREQ_PARTICIPANTS) {
      POLLING_CURRENTREQ_PARTICIPANTS.abort();
    }

    if (POLLING_TIMEOUT_PARTICIPANTS) {
      clearTimeout(POLLING_TIMEOUT_PARTICIPANTS);
    }

    POLLING_CURRENTREQ_PARTICIPANTS = null;

    POLLING_TIMEOUT_PARTICIPANTS = setTimeout(
      self.getParticipantsInIntervals.bind(self),
      POLLING_INTERVAL_PARTICIPANTS
    );
  });
};

CourseParticipantsList.prototype.getParticipants = function() {
  var self = this;
  self.isLoading(true);
  self.noParticipantsFound(false);

  var url =
    self.getUrlParticipantsBase() +
    self.API.getParticipants +
    '?sequencePk=' +
    self.sequencePk;

  if (self.participants().length > 0) {
    self.participants([]);
  }

  APIHelper.get(
    url,
    function(data) {
      if (data.length === 0) {
        self.noParticipantsFound(true);
      } else {
        data.forEach(function(participant) {
          self.makeParticipantPropertiesObservables(participant);
          self.participants.push(participant);
        });
        self.addOptions();
      }

      self.isLoading(false);

      if (self.enableAutoUpdate()) {
        self.getParticipantsInIntervals();
      }
    },
    function(error) {
      self.errorMessage(
        error.responseJSON ? error.responseJSON.message : error
      );
      self.isLoading(false);
    }
  );
};

CourseParticipantsList.prototype.getUrlParticipantsBase = function() {
  return '';
};
CourseParticipantsList.prototype.getSequenceInfoUrl = function() {
  var self = this;

  return self.getUrlParticipantsBase() + self.API.getSequenceInfo;
};
CourseParticipantsList.prototype.getPostParticipantUrl = function() {
  var self = this;

  return self.getUrlParticipantsBase() + self.API.postParticipant;
};
CourseParticipantsList.prototype.getPostCheckInTimeUrl = function(attendance) {
  var sequenceFk = 'sequenceFk=' + attendance.SequenceFk;
  var time = 'time=' + attendance.CheckInTime();
  var day = 'day=' + attendance.DayInSequence;

  var queryString = '?' + sequenceFk + '&' + time + '&' + day;

  return this.getUrlParticipantsBase() + this.API.postCheckInTime + queryString;
};

CourseParticipantsList.prototype.getPostCheckOutTimeUrl = function(attendance) {
  var self = this;

  var sequenceFk = 'sequenceFk=' + attendance.SequenceFk;
  var time = 'time=' + attendance.CheckOutTime();
  var day = 'day=' + attendance.DayInSequence;

  var queryString = '?' + sequenceFk + '&' + time + '&' + day;

  return (
    self.getUrlParticipantsBase() + self.API.postCheckOutTime + queryString
  );
};
CourseParticipantsList.prototype.getPostMobileNumberUrl = function(
  participant
) {
  var self = this;

  var aktorId = 'aktorId=' + participant.ParticipantActorId;
  var sequenceFk = 'sequenceFk=' + participant.SequencePk;
  var mobileNumber = 'mobileNumber=' + participant.MobileNumber();

  var queryString = '?' + aktorId + '&' + sequenceFk + '&' + mobileNumber;

  return (
    self.getUrlParticipantsBase() + self.API.postMobileNumber + queryString
  );
};
CourseParticipantsList.prototype.getNorwegianDate = function(newDate) {
  var today = new Date(newDate);
  return (
    today.getDate() + '.' + (today.getMonth() + 1) + '.' + today.getFullYear()
  );
};

CourseParticipantsList.prototype.updateOptions = function() {
  var self = this;

  self.participants().forEach(function(participant) {
    participant.StatusTexts().forEach(function(status) {
      if (
        status !== '' &&
        self.participantFilterOptions.indexOf(status) === -1
      ) {
        self.participantFilterOptions.push(status);
      }
    });
  });

  self.applyStoredFilters();
  self.createSubscribersForSelectedFilters();
};

CourseParticipantsList.prototype.addOptions = function() {
  var self = this;
  self.participantFilterOptions.removeAll();

  self.participantFilterOptions.push('Alle');

  self.participants().forEach(function(participant) {
    participant.StatusTexts().forEach(function(status) {
      if (
        status !== '' &&
        self.participantFilterOptions.indexOf(status) === -1
      ) {
        self.participantFilterOptions.push(status);
      }
    });
  });

  self.applyStoredFilters();
  self.createSubscribersForSelectedFilters();
};

CourseParticipantsList.prototype.addAnonOptions = function() {
  var self = this;
  self.anonymousParticipantsFilterOptions.removeAll();

  self.anonymousParticipantsFilterOptions.push('Alle');

  self.applyStoredFilters();
  self.createSubscribersForSelectedFilters();
};

CourseParticipantsList.prototype.filterParticipants = function() {
  var self = this;
  var filteredList = self.participants();

  var participantFilter = self.selectedFilterParticipant();
  if (
    participantFilter &&
    participantFilter !== self.participantFilterOptions()[0]
  ) {
    filteredList = ko.utils.arrayFilter(filteredList, function(participant) {
      var filter = '';
      participant.StatusTexts().forEach(function(status) {
        if (status === participantFilter) {
          filter = status;
        }
      });
      return filter;
    });
  }

  self.numberOfShowingParticipants(filteredList.length);
  return filteredList;
};

CourseParticipantsList.prototype.filterAnonymousParticipants = function() {
  var self = this;
  var filteredAnonymousParticipantsList = self.anonymousParticipants();

  var anonymousParticipantsFilter = self.selectedFilterAnonymousParticipants();
  if (
    anonymousParticipantsFilter &&
    anonymousParticipantsFilter !== self.anonymousParticipantsFilterOptions()[0]
  ) {
    filteredAnonymousParticipantsList = ko.utils.arrayFilter(
      filteredAnonymousParticipantsList,
      function(anon) {
        return anon.MobilePhone === anonymousParticipantsFilter;
      }
    );
  }

  self.numberOfShowingAnonymousParticipants(
    filteredAnonymousParticipantsList.length
  );
  return filteredAnonymousParticipantsList;
};
CourseParticipantsList.prototype.getCurrentTime = function(input) {
  var now = new Date(new Date());

  input(
    now.getHours() +
      ':' +
      (now.getMinutes().toString().length === 1 ? '0' : '') +
      now.getMinutes()
  );
};

CourseParticipantsList.prototype.getTimeFromDate = function(newDate) {
  if (newDate === null) return '';

  var today = new Date(newDate);

  return (
    today.getHours() +
    ':' +
    (today.getMinutes().toString().length === 1 ? '0' : '') +
    today.getMinutes()
  );
};

CourseParticipantsList.prototype.sortParticipants = function(header) {
  var self = this;

  if (self.activeSort === header) {
    header.asc = !header.asc;
  } else {
    self.activeSort = header;
  }
  var currentSorting = self.activeSort.asc ? self.compareAsc : self.compareDesc;
  var key = header.sortKey;
  switch (key) {
    case 'name':
      self.participants.sort(currentSorting.bind('Name'));
      break;
  }
};

CourseParticipantsList.prototype.sortAnonymousParticipants = function(header) {
  var self = this;

  if (self.activeSort === header) {
    header.asc = !header.asc;
  } else {
    self.activeSort = header;
  }
  var currentSorting = self.activeSort.asc ? self.compareAsc : self.compareDesc;
  var key = header.sortKey;
  switch (key) {
    case 'number':
      self.anonymousParticipants.sort(currentSorting.bind('number'));
      break;
    case 'in':
      self.anonymousParticipants.sort(currentSorting.bind('number'));
      break;
    case 'out':
      self.anonymousParticipants.sort(currentSorting.bind('number'));
      break;
  }
};

CourseParticipantsList.prototype.compareAsc = function(a, b) {
  return a[this] < b[this]
    ? -1
    : a[this] > b[this]
      ? 1
      : a[this] == b[this]
        ? 0
        : 0;
};

CourseParticipantsList.prototype.compareDesc = function(b, a) {
  return a[this] < b[this]
    ? -1
    : a[this] > b[this]
      ? 1
      : a[this] == b[this]
        ? 0
        : 0;
};

module.exports = CourseParticipantsList;
